<template>
	<main class="complete">
		<div class="icon_wrapper">
			<template v-if="result === 'true'">
				<img src="@/assets/img/common/complete.png" alt="complete" loading="lazy" />
				<div class="icon_title">
					<p>
						회원님의 아이디는<br /><b>{{ authStore.getMemberId }}</b> 입니다.
					</p>
				</div>
			</template>
			<template v-else>
				<img src="@/assets/img/common/exclamation.png" alt="notcomplete" loading="lazy" />
				<div class="icon_title">
					<p>{{ ACCOUNT_NOT_FOUND }}</p>
				</div></template
			>
		</div>
		<div class="c_fieldArea">
			<button
				class="c_button radius-x-small primary-fill save"
				@click="
					result === 'true'
						? $router.replace('/auth/login')
						: $router.replace({ path: '/auth/terms-agreement', query: { joinPath: 'normal' } })
				"
			>
				{{ result === 'true' ? CONFIRM_LOGIN : CONFIRM_SIGNUP }}
			</button>
		</div>
	</main>
</template>

<script setup lang="ts">
// core
import { useRoute } from 'vue-router';

// constant
import { ACCOUNT_NOT_FOUND, CONFIRM_LOGIN, CONFIRM_SIGNUP } from '@/constants/title';
// store
import { useAuthStore } from '@/stores/auth';

//variable
const route = useRoute();
const authStore = useAuthStore();
const result = route.query.result;
</script>

<style lang="scss" scoped>
.complete {
	display: flex;
	flex-direction: column;
	padding-top: var(--header-height);
	gap: var(--space-xx-large);
	max-width: 40rem;
	margin: 0 auto;
	justify-content: center;
	width: 100%;
	img {
		width: 12rem;
	}
	.icon_wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: var(--space-x-large);

		.icon_title {
			text-align: center;
			font-weight: var(--font-w-semi-bold);
			font-size: var(--space-large);
			line-height: 2.387rem;
			b {
				color: #1690ff;
			}
		}
	}
	.c_fieldArea {
		button {
			font-weight: var(--font-w-medium);
			font-size: var(--font-s-regular);
			line-height: 2.1rem;
			height: 4.8rem;
		}
	}
	@media screen and (max-width: 1280px) {
		padding: 0 2rem;
	}
}
</style>
